import { apiService } from "../../../../components/api/apiService";

const BASE = "/api/MCPResources";

export interface MCPResourceRow {
  id: string;
  resourceId: string;
  name: string;
  cat: string;
  type: string;
  isActive: boolean;
  createdAt: string;
}

export interface RegisterMCPResourcePayload {
  resourceId: string;
  name: string;
  category: string;
  type: string;
  description?: string;
  isActive: boolean;
}

function mapFromApi(res: {
  id: string;
  resourceId: string;
  name: string;
  category: string;
  type: string;
  isActive: boolean;
  createdAt: string;
}): MCPResourceRow {
  return {
    id: res.id,
    resourceId: res.resourceId,
    name: res.name,
    cat: res.category,
    type: res.type,
    isActive: res.isActive,
    createdAt: typeof res.createdAt === "string" ? res.createdAt.slice(0, 10) : new Date(res.createdAt).toISOString().slice(0, 10),
  };
}

export const mcpResourcesService = {
  async getAll(): Promise<MCPResourceRow[]> {
    const data = await apiService.get(BASE, {}, "backend");
    const list = data?.resources ?? [];
    return list.map(mapFromApi);
  },

  async register(payload: RegisterMCPResourcePayload): Promise<MCPResourceRow> {
    const res = await apiService.post(
      BASE,
      {
        resourceId: payload.resourceId,
        name: payload.name,
        category: payload.category,
        type: payload.type,
        description: payload.description ?? null,
        isActive: payload.isActive,
      },
      "backend"
    );
    return mapFromApi(res);
  },

  async update(id: string, payload: { isActive?: boolean }): Promise<MCPResourceRow | null> {
    const res = await apiService.put(`${BASE}/${id}`, payload, "backend");
    return res ? mapFromApi(res) : null;
  },

  async delete(id: string): Promise<void> {
    await apiService.delete(`${BASE}/${id}`, "backend");
  },

  /** Number of developer tokens that have this resource assigned (for delete warning). */
  async getAssignedTokenCount(id: string): Promise<{ assignedTokenCount: number }> {
    const data = await apiService.get(`${BASE}/${id}/assigned-token-count`, {}, "backend");
    return { assignedTokenCount: data?.assignedTokenCount ?? 0 };
  },
};
